import { List, Modal } from 'antd';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    padding: 24px;
  }
  .ant-modal-footer {
    border: none;
    margin-top: 24px;
    padding: 0;
  }
  .ant-modal-body {
    padding: 0px;
    p {
      margin-bottom: 0;
      padding-top: 16px;
    }
  }
`;

export const Name = styled.span`
  display: flex;
  flex-direction: column;
`;

export const Actions = styled.span`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  svg {
    font-size: 20px;
    height: 28px;
    border-radius: 4px;
    border: 1px solid ${props => props.theme.palette.background.grey2};
    &:hover {
      background-color: ${props => props.theme.palette.primary.main};
    }
  }
  &:hover {
    svg {
      fill: ${props => props.theme.palette.primary.light};
    }
  }
`;

export const ActionLink = styled.div`
  cursor: pointer;
`;

export const UsersListModal = styled(Modal)`
  .ant-modal-body {
    background: ${props => props.theme.palette.background.primary80};
    border-radius: 10px;
    padding: 30px 50px;

    h3 {
      text-align: center;
      font-weight: normal;
      font-size: 24px;
      color: ${props => props.theme.palette.text.primary};
    }
  }
`;

export const UsersList = styled(List)`
  border: 1px solid ${props => props.theme.palette.border};
  border-radius: 4px;
  height: 250px;
  overflow-y: auto;
  background: ${props => props.theme.palette.background.light};
`;

export const UsersListItem = styled(List.Item)`
  border-bottom: 1px solid ${props => props.theme.palette.background.secondary} !important;
  height: auto;
  &:hover {
    background: transparent !important;
  }
`;
